import { render, staticRenderFns } from "./StepCustomizedLogoOnPhoto.vue?vue&type=template&id=48460a60&scoped=true&"
import script from "./StepCustomizedLogoOnPhoto.vue?vue&type=script&lang=js&"
export * from "./StepCustomizedLogoOnPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48460a60",
  null
  
)

export default component.exports